import { $CurrentTraffic, $EnterTraffic } from '@lemon8/web-app-shared/atom';
import { ExtractAtomValue } from 'jotai';
import { defineProxyAtom } from '@lemon8/web-app-shared/util';

export interface IHomepageEnterTraffic extends ExtractAtomValue<typeof $EnterTraffic> {
  pageType: 'website_homepage';
}

export const $HomepageEnterTraffic = defineProxyAtom<IHomepageEnterTraffic, ExtractAtomValue<typeof $EnterTraffic>>(
  $EnterTraffic,
);
$HomepageEnterTraffic.debugLabel = '$HomepageEnterTraffic';

export const $HomepageCurrentTraffic = defineProxyAtom($CurrentTraffic);
$HomepageCurrentTraffic.debugLabel = '$HomepageCurrentTraffic';
